import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { TabContent } from "@/components/common/PageLayout";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { ClientPoliciesDatagrid } from "@/resources/clients/components/ClientPoliciesDatagrid";
import { CurrentPolicyCard } from "@/resources/claimants/components/CurrentPolicyCard";
import { Grid2 as Grid, Box } from "@mui/material";
import { ClientContactsList } from "./ClientContactsList";
import { ResourceName } from "@/types";

export const ClientOverviewTab = ({ drawerExpanded }: { drawerExpanded: boolean }) => {
  return (
    <TabContent>
      {/* Client Overview Information */}
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: drawerExpanded ? 12 : 8 }}>
          <ShowAccordionSection label="Client Information" defaultExpanded>
            <EditableGrid
              fields={clientOverviewFields}
              isDrawerOpen={drawerExpanded}
              recordType={ResourceName.CLIENTS}
            />
          </ShowAccordionSection>
          <ShowAccordionSection label="Contacts" defaultExpanded>
            <ClientContactsList />
          </ShowAccordionSection>
        </Grid>
        <Grid size={{ xs: 12, md: drawerExpanded ? 12 : 4 }}>
          <ShowAccordionSection label="Current Policy" defaultExpanded>
            <CurrentPolicyCard context="client" />
          </ShowAccordionSection>
          <ShowAccordionSection label="Associated Policies">
            <Box sx={{ p: 2 }}>
              <ClientPoliciesDatagrid />
            </Box>
          </ShowAccordionSection>
        </Grid>
      </Grid>
    </TabContent>
  );
};

const clientOverviewFields: EditorField[] = [
  { source: "aegle_id" },
  { source: "client_legal_name" },
  { source: "client_short_name" },
  {
    source: "client_state_headquartered",
    type: "state",
  },
  { source: "client_parent_co" },
  { source: "broker_agent_of_record" },
  {
    source: "has_children_co",
    type: "boolean",
  },
  {
    source: "has_active_policy",
    type: "boolean",
  },
];
